<template>
  <div class="box-card" shadow="never"
       :body-style="{ backgroundColor: '#F6F8FB', padding: '0' }">
    <ul class="scroll-items">
      <li v-for="item in queryCond">
        <div style="display: flex;align-items: center;padding: 4px 8px;justify-content: space-between;">
            <div class="filter-text">
              <span>{{column_mapper[item.columnName] ? column_mapper[item.columnName].slice(0, column_mapper[item.columnName].lastIndexOf(':')) : "" }}-{{ filter_mapper[item.filter] }}</span>
              <span>{{item.columnValue }}</span>
            </div>
          <img class="hoverCls" src="../../../assets/img/delete_select.png" @click="$emit('removeSelect',item)">
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import selectoption from "@/component/assets/selectoption.json";

export default {
  name: "CustomFilterDrawer",
  // props:["items"],
  props:["column_mapper","queryCond"],
  data(){
    return {
      filter_mapper:{}
      // itemSelectID:0,
      // leftItems:[
      //   {
      //     id:0,
      //     name:"业绩表现",
      //     key:"performance"
      //   },
      //   {
      //     id:1,
      //     name:"企业资产",
      //     key:"asset"
      //   }
      // ],
    }
  },
  // methods:{
  //   leftAsideItemClick(item,idx){
  //     console.log('leftAsideItemClick',item.id)
  //     this.itemSelectID = item.id
  //     this.$emit('selectChange',item.key)
  //   }
  // }
  mounted() {
    this.selectShortcutId = this.selectShortcutIdProps
    this.filter_mapper = selectoption.filter_mapper
  },

  watch:{
    selectShortcutIdProps(newVal){
      // console.log('selectShortcutIdProps',newVal)
      this.selectShortcutId = newVal
    }
  },

  methods:{
    shourtcutSelect(key){
      this.$emit("shourtcutSelectChange",key)
    }
  }
}
</script>

<style scoped lang="scss">
.hoverCls{
  width:12px;
  height:12px;
}
.filter-text{
  display: flex;
  flex-direction: column;
  font-size:12px;
  font-weight:bold;
  margin-right:4px;
}
.scroll-items{
  height: calc(100% - 25px);
}
.box-card {
  width: 100%;
  height: 100%;

ul {
  //height: 100% !important;
  overflow-y: auto;

li {
  position: relative;
//width: 272px;
  font-size: 16px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: #3F464E;
  //border-bottom: 1px solid rgba(213, 215, 223, .5);
// &:last-of-type{
    //   border: none;
    // }
cursor: default;

&:hover {
   cursor: pointer;
   background: #EBEFF7;
 }

.text {

  display: flex;
  align-items: center;
  text-align: center;
  //height:41px;
  font-size: 12px;
  padding:4px 10px 3px 6px;
.el-input .el-input__count .el-input__count-inner {
  background: none;
}

.el-input__inner {
  height: 50px;
//width: 272px;
  background: #EBEFF7;
  border: none;
// border-left:1px solid rgba(57, 148, 241, .5);
  font-size: 16px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  border-radius: 0;
// color: #3994F1;
}

input::-webkit-input-placeholder {
  font-size: 16px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
  font-weight: 400;
  color: rgba(57, 148, 241, .4);
}

.dot {
  width: 10px;
  height: 10px;
  margin-right: 6px;
}
}

.btn {
  position: absolute;
  right: 30px;
  top: 19px;
}

}

.li-active {
  background-color: #E6E9EE;
  color: #909399;

&:hover {
   background-color: #E6E9EE;
  opacity: .6;
 }
}
}
}
</style>
